import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Grid,
  Typography,
} from "@mui/material";

import OnlinePredictionIcon from "@mui/icons-material/OnlinePrediction";
import HistoryIcon from "@mui/icons-material/History";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import GridViewIcon from "@mui/icons-material/GridView";
import DesktopWindowsIcon from "@mui/icons-material/DesktopWindows";
import StayCurrentPortraitIcon from "@mui/icons-material/StayCurrentPortrait";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

import useMediaQuery from "@mui/material/useMediaQuery";

import { getUser } from "../../Model/LocalStorage";
import { postUndo, hallBid } from "../../Model/DeclaratorModel";

const TableUserOnline = ({
  socketDeclarator,
  userOnline,
  LiveData,
}) => {
  const phoneMatch = useMediaQuery("(min-width:1200px)");

  const [onlineUser, setOnlineUser] = useState([]);
  const [bidder, setBidder] = useState([]);
  const [userID, setUserId] = useState("");
  const [hammer, setHammer] = useState("");

  // ---------------------------------------------------------
  // HALL BID
  // ---------------------------------------------------------
  const handleHallBid = () => {
    try {
      async function postHallBid() {
        const bidData = {
          auction_id:
            LiveData.auction_details.auction_id,
          setId: LiveData.auction_details.id,
          lot_number:
            LiveData.lot.details[0].lot_number,
        };

        const results = await hallBid(bidData);

        if (results.success === true) {
          socketDeclarator.emit("send_Bid_amount", {
            status: 2,
          });
        } else if (results.success === false) {
          alert(`Error !: ${results.msg}`);
        }
      }

      postHallBid().catch((error) => {
        console.log(error);
      });
    } catch (error) {
      console.log(error);
    }
  };

  // ---------------------------------------------------------
  // UNDO BID
  // ---------------------------------------------------------
  const handleClickUndo = (val) => {
    const dataArray = {
      auction_id:
        LiveData.auction_details.auction_id,
      setId: LiveData.auction_details.id,
      lot_number:
        LiveData.lot.details[0].lot_number,
      bid_history_id: val,
    };

    try {
      async function functionUndo() {
        const results = await postUndo(dataArray);

        if (results.success === true) {
          socketDeclarator.emit("send_status", {
            status: results.success,
            message: "undo",
          });
        } else {
          alert(results.msg);
        }
      }

      functionUndo().catch(console.error);
    } catch (error) {
      console.log(error);
    }
  };

  // ---------------------------------------------------------
  // CONNECTED USERS
  // ---------------------------------------------------------
  useEffect(() => {
    setOnlineUser(
      Array.isArray(userOnline)
        ? userOnline
        : []
    );
  }, [userOnline]);

  // ---------------------------------------------------------
  // BID HISTORY
  // ---------------------------------------------------------
  useEffect(() => {
    setHammer(LiveData?.lot?.details[0].hp );
    console.log("LiveData", LiveData)

    setBidder(
      Array.isArray(LiveData?.bid_history)
        ? LiveData.bid_history
        : []
    );
  }, [LiveData]);

  // ---------------------------------------------------------
  // CURRENT USER
  // ---------------------------------------------------------
  useEffect(() => {
    const getUserList = async () => {
      try {
        const user = await getUser();

        if (user) {
          setUserId(user.id);
        }
      } catch (error) {
        console.error(
          "Failed to get user info:",
          error
        );
      }
    };

    getUserList();
  }, []);

  // ---------------------------------------------------------
  // PLATFORM DISPLAY
  // ---------------------------------------------------------
  const getPlatform = (season) => {
    if (
      season?.platform === "mobile" ||
      season?.platform === "MOBILE" ||
      season?.mobile === true
    ) {
      return "MOBILE";
    }

    if (
      season?.platform === "web" ||
      season?.platform === "WEB" ||
      season?.mobile === false
    ) {
      return "WEB";
    }

    return "WEB";
  };

  // ---------------------------------------------------------
  // PLATFORM ICON
  // ---------------------------------------------------------
  const getPlatformIcon = (season) => {
    const platform = getPlatform(season);

    if (platform === "MOBILE") {
      return (
        <StayCurrentPortraitIcon
          fontSize="small"
          style={{
            marginRight: 5,
          }}
        />
      );
    }

    return (
      <DesktopWindowsIcon
        fontSize="small"
        style={{
          marginRight: 5,
        }}
      />
    );
  };

  // ---------------------------------------------------------
  // COUNTRY FLAG
  // ---------------------------------------------------------
  const getCountryFlag = (season) => {
    const country =
      season?.countryCode ||
      season?.country_code ||
      season?.country;

    if (!country) {
      return "";
    }

    const code = String(country).toUpperCase();

    if (code.length !== 2) {
      return "";
    }

    return String.fromCodePoint(
      ...[...code].map(
        (char) =>
          127397 + char.charCodeAt(0)
      )
    );
  };

  // ---------------------------------------------------------
  // SAFE HAMMER VALUE
  // ---------------------------------------------------------
  const getHammerValue = (value) => {
    if (
      value === null ||
      value === undefined
    ) {
      return 0;
    }

    const numberValue = Number(value);

    if (Number.isNaN(numberValue)) {
      return 0;
    }

    return numberValue.toLocaleString();
  };

  // If the winning hammer is exactly the configured absentee amount,
  // allow Hall Bid even when the history row is marked INTERNET BIDDER.
  const isAbsenteeHallBid = (val) => {
    if (val?.win_status !== "WIN") return false;

    const absenteeAmount = Number(LiveData?.absentee || 0);
    const hammerAmount = Number(val?.hammer || 0);

    return absenteeAmount > 0 && hammerAmount === absenteeAmount;
  };

  // ---------------------------------------------------------
  // CONNECTED TIME
  // ---------------------------------------------------------
  const getConnectedTime = (value) => {
    if (!value) {
      return null;
    }

    try {
      const date = new Date(value);

      if (Number.isNaN(date.getTime())) {
        return value;
      }

      return date.toLocaleString();
    } catch (error) {
      return value;
    }
  };

  return (
    <div>
      <Divider />

      <Box style={{ padding: 10 }}>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: "-10px",
            width: "calc(100% + 20px)",
            marginLeft: "-10px",
          }}
        >
          {/* =====================================================
              CONNECTED USERS
          ====================================================== */}

          <Grid
            item
            xs={
              phoneMatch === true
                ? 5
                : 12
            }
            style={{
              border:
                ".5px solid rgb(225 220 220)",
              paddingLeft: 0,
            }}
          >
            <Box>
              <div
                style={{
                  paddingBottom: 10,
                  display: "flex",
                  justifyContent:
                    "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  style={{
                    fontWeight: "bold",
                    marginLeft: 15,
                  }}
                >
                  <OnlinePredictionIcon />

                  {" Online : "}

                  <b
                    style={{
                      backgroundColor:
                        "#12bc12",
                      color: "white",
                      padding: "5px 10px",
                      borderRadius: 5,
                      marginLeft: 10,
                    }}
                  >
                    {onlineUser.length}
                  </b>
                </Typography>
              </div>

              <Divider />
            </Box>

            <Box
              style={{
                display: "flex",
                background: "white",
                justifyContent:
                  "space-between",
              }}
            >
              <List
                style={{
                  width: "100%",
                  background: "white",
                  position: "relative",
                  overflowY: "auto",
                  maxHeight: 285,
                }}
              >
                {onlineUser.length > 0 ? (
                  onlineUser.map(
                    (season, index) => {
                      const platform =
                        getPlatform(season);

                      const ip =
                        season?.ip ||
                        season?.IP ||
                        season?.clientIp ||
                        "Unknown";

                      const country =
                        season?.country ||
                        season?.countryName ||
                        "Unknown";

                      const city =
                        season?.city ||
                        "Unknown";

                      const region =
                        season?.region ||
                        "";

                      const flag =
                        getCountryFlag(
                          season
                        );

                      return (
                        <ListItem
                          key={
                            season?.socketId ||
                            season?.userId ||
                            index
                          }
                          style={{
                            paddingBottom: 7,
                            paddingTop: 7,
                            alignItems:
                              "flex-start",
                          }}
                        >
                          <ListItemText
                            align="left"
                            primary={
                              <Box>
                                {/* USER */}
                                <Box
                                  style={{
                                    display:
                                      "flex",
                                    alignItems:
                                      "center",
                                  }}
                                >
                                  {getPlatformIcon(
                                    season
                                  )}

                                  <Typography
                                    style={{
                                      fontSize: 14,
                                      fontWeight:
                                        "bold",
                                    }}
                                    variant="body2"
                                    color="text.primary"
                                  >
                                    {season?.email ||
                                      season?.userId ||
                                      "Unknown User"}
                                  </Typography>
                                </Box>

                                {/* PLATFORM + IP */}
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  style={{
                                    display:
                                      "block",
                                    marginLeft: 28,
                                    marginTop: 2,
                                  }}
                                >
                                  <b>
                                    {platform}
                                  </b>

                                  {" • "}

                                  IP: {ip}
                                </Typography>

                                {/* COUNTRY + CITY */}
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  style={{
                                    display:
                                      "block",
                                    marginLeft: 28,
                                    marginTop: 2,
                                  }}
                                >
                                  {flag && (
                                    <span
                                      style={{
                                        marginRight: 5,
                                      }}
                                    >
                                      {flag}
                                    </span>
                                  )}

                                  {country}

                                  {city &&
                                    city !==
                                      "Unknown" && (
                                      <>
                                        {" • "}
                                        {city}
                                      </>
                                    )}

                                  {region && (
                                    <>
                                      {" • "}
                                      {region}
                                    </>
                                  )}
                                </Typography>

                                {/* GROUP */}
                                {season?.group && (
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    style={{
                                      display:
                                        "block",
                                      marginLeft: 28,
                                      marginTop: 2,
                                    }}
                                  >
                                    Group:{" "}
                                    {
                                      season.group
                                    }
                                  </Typography>
                                )}

                                {/* DEVICE */}
                                {season?.device && (
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    style={{
                                      display:
                                        "block",
                                      marginLeft: 28,
                                      marginTop: 2,
                                      maxWidth:
                                        "95%",
                                      overflow:
                                        "hidden",
                                      textOverflow:
                                        "ellipsis",
                                      whiteSpace:
                                        "nowrap",
                                    }}
                                    title={
                                      season.device
                                    }
                                  >
                                    Device:{" "}
                                    {
                                      season.device
                                    }
                                  </Typography>
                                )}

                                {/* CONNECTED TIME */}
                                {season?.connectedAt && (
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    style={{
                                      display:
                                        "block",
                                      marginLeft: 28,
                                      marginTop: 2,
                                    }}
                                  >
                                    Connected:{" "}
                                    {getConnectedTime(
                                      season.connectedAt
                                    )}
                                  </Typography>
                                )}
                              </Box>
                            }
                          />
                        </ListItem>
                      );
                    }
                  )
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent:
                        "center",
                      marginTop: 5,
                      width: "100%",
                    }}
                  >
                    <Typography color="text.secondary">
                      No connected users
                    </Typography>
                  </Box>
                )}
              </List>
            </Box>
          </Grid>

          {/* =====================================================
              BID HISTORY
          ====================================================== */}

          <Grid
            item
            xs={
              phoneMatch === true
                ? 7
                : 12
            }
            style={{
              border:
                ".5px solid rgb(225 220 220)",
              paddingLeft: 0,
              background:
                "rgb(248 248 248)",
            }}
          >
            <div>
              <div
                style={{
                  paddingBottom: 10,
                  display: "flex",
                  justifyContent:
                    "space-between",
                }}
              >
                <Typography
                  style={{
                    fontWeight: "bold",
                    marginLeft: 15,
                  }}
                >
                  <HistoryIcon /> Bid History :
                </Typography>
              </div>

              <Divider />

              <Box
                style={{
                  display: "flex",
                  background: "white",
                  justifyContent:
                    "space-between",
                }}
              >
                <List
                  style={{
                    width: "100%",
                    background:
                      "rgb(248 248 248)",
                    position: "relative",
                    overflow: "auto",
                    height: 300,
                    flexDirection:
                      "column-reverse",
                  }}
                >
                  {bidder.length ? (
                    bidder.map(
                      (val, index) => {
                        return (
                          <ListItem
                            key={index}
                            style={{
                              paddingBottom: 0,
                              paddingTop: 0,
                            }}
                          >
                            <ListItemText
                              align="left"
                              primary={
                                <div
                                  style={{
                                    display:
                                      "flex",
                                    flexDirection:
                                      "column",
                                    lineHeight: 1,
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize:
                                        val.win_status ===
                                        "WIN"
                                          ? 15
                                          : 12,
                                      color:
                                        val.win_status ===
                                        "WIN"
                                          ? "green"
                                          : "black",
                                      fontWeight:
                                        val.win_status ===
                                        "WIN"
                                          ? "bold"
                                          : "normal",
                                      display:
                                        "block",
                                      margin: 0,
                                      padding: 0,
                                    }}
                                  >
                                    {val.email}
                                  </span>

                                  <span
                                    style={{
                                      fontSize: 11,
                                      color: "gray",
                                      display:
                                        "block",
                                      margin: 0,
                                      padding: 0,
                                    }}
                                  >
                                    {val.name} {userID === val.userId && " (You)"}
                                  </span>
                                </div>
                              }
                            />

                            <Box
                              style={{
                                width: 100,
                              }}
                            />

                            <ListItemText
                              align="right"
                              primary={
                                <React.Fragment>
                                  {(
                                  userID === val.userId &&
                                        val.hammer === hammer &&
                                        val.win_status === "WIN" &&
                                        (
                                          val.bidder_type === "FLOOR BIDDER" ||
                                          val.bidder_type === "TELEPHONE BIDDER"||
                                          val.bidder_type === "HALL BIDDER"
                                        )
                                      ) ? (
                                    <Button
                                      fullWidth
                                      variant="contained"
                                      style={{
                                        background:
                                          val.bidder_type ===
                                          "FLOOR BIDDER"
                                            ? "red"
                                            : "green",
                                        color:
                                          "white",
                                      }}
                                      onClick={() =>
                                        handleClickUndo(
                                          val.bid_history_id
                                        )
                                      }
                                      startIcon={
                                        val.bidder_type ===
                                        "FLOOR BIDDER" ? (
                                          <GridViewIcon />
                                        ) : (
                                          <PhoneInTalkIcon />
                                        )
                                      }
                                    >
                                      {"Php " +
                                        getHammerValue(
                                          val.hammer
                                        )}
                                    </Button>
                                  ) : val.win_status ===
                                      "WIN" ? (
                                    val.bidder_type ===
                                      "INTERNET BIDDER" &&
                                    !isAbsenteeHallBid(val) ? (
                                      <Typography
                                        style={{
                                          fontSize: 15,
                                        }}
                                        variant="body2"
                                      >
                                        {"Php " +
                                          getHammerValue(
                                            val.hammer
                                          )}
                                      </Typography>
                                    ) : (
                                      <div
                                        style={{
                                          backgroundColor:
                                            "rgb(24 118 210)",
                                          border: "none",
                                          color: "white",
                                          padding: "5px 15px",
                                          textAlign: "center",
                                          textDecoration: "none",
                                          display: "inline-block",
                                          borderRadius: 5,
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          handleHallBid()
                                        }
                                      >
                                        <Typography
                                          style={{
                                            fontSize: 15,
                                            color: "white",
                                          }}
                                          variant="body2"
                                        >
                                          {"Php " +
                                            getHammerValue(
                                              val.hammer
                                            )}
                                        </Typography>
                                      </div>
                                    )
                                  ) : (
                                    <Typography
                                      style={{
                                        fontSize: 12,
                                      }}
                                      variant="body2"
                                      color="text.primary"
                                    >
                                      {"Php " +
                                        getHammerValue(
                                          val.hammer
                                        )}
                                    </Typography>
                                  )}
                                </React.Fragment>
                              }
                            />
                          </ListItem>
                        );
                      }
                    )
                  ) : (
                    <ListItemText
                      gutterBottom
                      align="left"
                      primary={
                        <React.Fragment>
                          <Typography
                            style={{
                              fontSize: 15,
                              textAlign:
                                "center",
                            }}
                            variant="body2"
                            color="text.primary"
                          >
                            No Records Found
                          </Typography>
                        </React.Fragment>
                      }
                    />
                  )}
                </List>
              </Box>
            </div>
          </Grid>
        </Grid>

        <Divider />
      </Box>
    </div>
  );
};

export default TableUserOnline;